import { Injectable } from '@angular/core';
import * as alertify from 'alertifyjs/build/alertify.js';

//declare let alertify: any;

@Injectable()
export class AlertifyService {
  constructor() {
    alertify.set('notifier', 'position', 'top-right');
  }

  confirm(message: string, okCallback: () => any) {
    alertify.confirm(message, function (e) {
      if (e) {
        okCallback();
      } else {
      }
    });
  }

  successfully(message: string) {
    this.success(`${message} successfully`);
  }

  editSuccess(message: string) {
    this.success(`Edit ${message} successfully`);
  }

  deleteSuccess(message: string) {
    this.success(`Delete ${message} successfully`);
  }

  success(message: string, wait = 5) {
    alertify.success(message, wait);
  }

  error(message: string, wait = 10) {
    alertify.error(message, wait);
  }

  warning(message: string, wait = 5) {
    alertify.warning(message, wait);
  }

  message(message: string) {
    alertify.message(message);
  }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/services/alertify.service.ts